"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const salaryadvanceformula_form_1 = __importDefault(require("./salaryadvanceformula.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const AriFormUtils = __importStar(require("../../../utils/utils"));
const sdk_1 = require("@ariform/core/sdk");
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class SalaryAdvanceFormulaComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.renderSalaryCriteriaList = () => {
            return this.salaryCriteriaList.length > 0 ? this.salaryCriteriaList.map((value) => {
                return `
      <div item-code=${value.Code} item-type='attr' item-name=${value.Name} class="${sdk_1.AriForm.tailwindPrefix}border-b-[#EAECF0] ${this.component.key}-salary-advance-container-dropdown-select-item ${sdk_1.AriForm.tailwindPrefix}border-b ${sdk_1.AriForm.tailwindPrefix}py-[10px]">${AriFormUtils.getLangText(value.Description)} - ( ${!this.component.showCode ? value.Name : value.Code} )</div>
    `;
            }).join('') : '';
        };
        this.renderOperations = () => {
            return this.operations.length > 0 ? this.operations.map(v => {
                return `
      <div item-code=${v.Code} item-type='operation' item-name=${v.Name} class="${sdk_1.AriForm.tailwindPrefix}border-b-[#EAECF0] ${this.component.key}-salary-advance-container-dropdown-select-item ${sdk_1.AriForm.tailwindPrefix}border-b ${sdk_1.AriForm.tailwindPrefix}py-[10px]">${v.Code} ${AriFormUtils.getLangText(v.Name)}</div>
    `;
            }).join('') : '';
        };
        this.checkLastItemIsInputType = () => {
            const isLasted = this.dataFormula[this.dataFormula.length - 1];
            if ((isLasted === null || isLasted === void 0 ? void 0 : isLasted.type) === 'input') {
                return isLasted;
            }
            return false;
        };
        this.getAllItems = () => {
            document.querySelectorAll(`#${this.component.id} .${this.component.key}-salary-advance-container-dropdown-select-item`).forEach((value) => {
                value.addEventListener('click', () => {
                    var _a;
                    const itemCode = ((_a = value.getAttribute('item-code')) === null || _a === void 0 ? void 0 : _a.trim()) || '';
                    const inputRef = this.refs[`${this.component.key}-salary-advance-formula-input`];
                    const startPos = inputRef.selectionStart;
                    const endPos = inputRef.selectionEnd;
                    const originalValue = inputRef.value;
                    const newValue = originalValue.substring(0, startPos) +
                        itemCode +
                        originalValue.substring(endPos);
                    inputRef.value = newValue;
                    this.dataFormulaText = newValue;
                    // Đưa con trỏ về ngay sau item vừa chèn
                    const caretPos = startPos + itemCode.length;
                    inputRef.setSelectionRange(caretPos, caretPos);
                    inputRef.focus();
                });
            });
        };
        this.checks = [];
        this.salaryCriteriaList = [];
        this.operations = [
            {
                Name: 'Sum',
                Code: '+'
            }, {
                Name: 'Substraction',
                Code: '-'
            },
            {
                Name: 'Multiplication',
                Code: '*'
            },
            {
                Name: 'Division',
                Code: '/'
            },
            {
                Name: 'Opening parenthesis',
                Code: '('
            },
            {
                Name: 'Closing parenthesis',
                Code: ')'
            },
        ];
        this.dataFormula = [];
        this.itemEdit = null;
        this.tabChoose = 'attributes';
        this.cursorIndex = -1;
        this.dataFormulaText = '';
        this.validMathExpression = false;
        this.eventHandlers = [];
        this.formulaCodes = [];
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'salaryAdvanceFormula',
            label: 'Salary Advance Formula',
            dataSrc: 'aripost',
            dataSourcePath: 'dataSource',
            defaultRulePath: 'rule',
            displayInfo: true,
            defaultRule: '',
            formulaDataSource: '',
            align: 'justify-content-start',
            action: 'event'
        }, ...extend);
    }
    get defaultSchema() {
        return SalaryAdvanceFormulaComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    render() {
        var view = `<div class="${sdk_1.AriForm.tailwindPrefix}cursor-pointer" ref="${this.component.key}-salary-advance-formula">
  <div
    class="${sdk_1.AriForm.tailwindPrefix}p-2 ${sdk_1.AriForm.tailwindPrefix}rounded-[6px] ${this.component.disabled ? '' : ''} ${sdk_1.AriForm.tailwindPrefix}flex-wrap ${sdk_1.AriForm.tailwindPrefix}min-h-10 ${sdk_1.AriForm.tailwindPrefix}border ${sdk_1.AriForm.tailwindPrefix}border-gray-200 !${sdk_1.AriForm.tailwindPrefix}bg-[${this.component.disabled ? `#e9ecef` : '#FFFFFF'}] ${sdk_1.AriForm.tailwindPrefix}flex ${sdk_1.AriForm.tailwindPrefix}gap-1 ${sdk_1.AriForm.tailwindPrefix}w-full">
    <textarea ${this.component.disabled ? 'disabled' : ''} rows="1" ref="${this.component.key}-salary-advance-formula-input"
      placeholder="${AriFormUtils.getLangText(this.component.placeholder)}"
      class=" ${this.component.key}-salary-advance-formula-input focus-visible:${sdk_1.AriForm.tailwindPrefix}outline-none focus-visible:${sdk_1.AriForm.tailwindPrefix}border-none input-formula-custom ${sdk_1.AriForm.tailwindPrefix}text-[#1CB256] ${sdk_1.AriForm.tailwindPrefix}tracking-[2.5px] ${sdk_1.AriForm.tailwindPrefix}flex-1"
       >${this.dataFormulaText || ''}</textarea>
  </div>
  <div ref="${this.component.key}-salary-advance-formula-validate"
    class="validate-formula ${sdk_1.AriForm.tailwindPrefix}text-[12px] ${sdk_1.AriForm.tailwindPrefix}mt-[5px]  ${sdk_1.AriForm.tailwindPrefix}hidden ${this.validMathExpression ? `${sdk_1.AriForm.tailwindPrefix}text-[#009462]` : `${sdk_1.AriForm.tailwindPrefix}text-[#E33100]`}">
    ${AriFormUtils.getLangText('Invalid formula')}</div>
  <div ref="${this.component.key}-salary-advance-container-dropdown-select"
    class="container-dropdown-select-formula ${sdk_1.AriForm.tailwindPrefix}bg-[#FFFFFF] ${sdk_1.AriForm.tailwindPrefix}px-[25px] ${sdk_1.AriForm.tailwindPrefix}py-[10px] ${sdk_1.AriForm.tailwindPrefix}border ${sdk_1.AriForm.tailwindPrefix}border-[#E1E1E1] ${sdk_1.AriForm.tailwindPrefix}shadow-lg ${sdk_1.AriForm.tailwindPrefix}hidden">
    <div class="${sdk_1.AriForm.tailwindPrefix}pb-3 ${sdk_1.AriForm.tailwindPrefix}uppercase ${sdk_1.AriForm.tailwindPrefix}font-medium">
      ${AriFormUtils.getLangText('All Libraries')}</div>
    <div class="${sdk_1.AriForm.tailwindPrefix}flex ${sdk_1.AriForm.tailwindPrefix}items-center ${sdk_1.AriForm.tailwindPrefix}gap-3">
      <div ref="${this.component.key}-salary-advance-formula-attributes"
        class="${sdk_1.AriForm.tailwindPrefix}p-2 ${sdk_1.AriForm.tailwindPrefix}bg-[#BFD9FF] ">
        ${AriFormUtils.getLangText('Attributes')}</div>
      <div ref="${this.component.key}-salary-advance-formula-operation"
        class="${sdk_1.AriForm.tailwindPrefix}p-2 ${sdk_1.AriForm.tailwindPrefix}bg-[#F4F4F4] ">
        ${AriFormUtils.getLangText('Operation')}</div>
    </div>
    <div ref="${this.component.key}-salary-advance-formula-content" class="dropdown-select-formula-content"></div>
  </div>
</div>`;
        return super.render(view);
    }
    setValue(value, flags = {}) {
        super.setValue(value, flags);
    }
    setRule(rule) {
        var formulaDataSource = JSON.parse(this.formulaDataSource);
        var defaultRule = rule;
        try {
            defaultRule = rule === '' ? [] : JSON.parse(rule);
        }
        catch (_a) {
            //do nothing
        }
        var items = Array.prototype.slice.call(this.refs[`${this.component.key}-builderFormula`], 0);
        items.forEach(item => {
            this.attachBuilder(item, formulaDataSource, defaultRule);
        });
        this.setValue(defaultRule);
    }
    getValue() {
        return this.value;
    }
    bindData(dataValue) {
        this.setValue(dataValue);
        const input = this.refs[`${this.component.key}-salary-advance-formula-input`];
        input.value = dataValue.replace(/\s+/g, '');
        this.dataFormulaText = input.value;
        input.style.height = 'auto'; // Reset chiều cao về auto
        input.style.height = input.scrollHeight + 'px';
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var _a, _b, _c, _d;
        const refs = {};
        refs[`${this.component.key}-salary-advance-formula`] = 'single';
        refs[`${this.component.key}-salary-advance-formula-attributes`] = 'single';
        refs[`${this.component.key}-salary-advance-formula-operation`] = 'single';
        refs[`${this.component.key}-salary-advance-formula-content`] = 'single';
        refs[`${this.component.key}-salary-advance-container-dropdown-select`] = 'single';
        refs[`${this.component.key}-salary-advance-formula-items`] = 'single';
        refs[`${this.component.key}-salary-advance-formula-input`] = 'single';
        refs[`${this.component.key}-salary-advance-formula-validate`] = 'single';
        this.loadRefs(element, refs);
        let isDragging = false;
        const handleInput = () => {
            var _a;
            const input = this.refs[`${this.component.key}-salary-advance-formula-input`];
            input.value = (_a = input.value.replace(/\s+/g, '')) === null || _a === void 0 ? void 0 : _a.toUpperCase();
            this.dataFormulaText = input.value;
            input.style.height = 'auto';
            input.style.height = input.scrollHeight + 'px';
        };
        const isValidExpression = (input) => {
            if (!/^[0-9a-zA-Z+\-*/(). ]+$/.test(input))
                return false;
            let stack = [];
            for (let char of input) {
                if (char === '(')
                    stack.push(char);
                else if (char === ')') {
                    if (stack.length === 0)
                        return false;
                    stack.pop();
                }
            }
            if (stack.length !== 0)
                return false;
            const expr = input.replace(/\s+/g, '');
            if (/[+\-*/]{2,}/.test(expr))
                return false;
            if (/^[+/*]/.test(expr) || /[+\-*/.]$/.test(expr))
                return false;
            return true;
        };
        const validateExpression = (input) => {
            const validCodes = new Set([
                ...this.salaryCriteriaList.map(v => v.Code),
                ...this.operations.map(o => o.Code)
            ]);
            const sortedCodes = Array.from(validCodes).sort((a, b) => b.length - a.length);
            const escapedCodes = sortedCodes.map(code => code.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));
            const codePattern = new RegExp(escapedCodes.join('|'), 'g');
            const matchedCodes = input.match(codePattern) || [];
            let inputWithoutCodes = input;
            for (const code of matchedCodes) {
                inputWithoutCodes = inputWithoutCodes.replace(new RegExp(code.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), '');
            }
            const cleaned = inputWithoutCodes.replace(/\s+/g, '');
            if (!/^[0-9+\-*/().]*$/.test(cleaned))
                return false;
            const invalidTokens = matchedCodes.filter(token => !validCodes.has(token));
            return invalidTokens.length === 0;
        };
        const closeWhenClickOut = (event) => {
            var _a, _b, _c;
            const isClickInside = (_a = this.refs[`${this.component.key}-salary-advance-formula`]) === null || _a === void 0 ? void 0 : _a.contains(event.target);
            if (isDragging)
                return;
            if (!isClickInside) {
                const formula = this.dataFormulaText.trim();
                const validateSyntax = isValidExpression(formula);
                const validateCodes = validateExpression(formula);
                const errorRef = this.refs[`${this.component.key}-salary-advance-formula-validate`];
                const dropdownRef = this.refs[`${this.component.key}-salary-advance-container-dropdown-select`];
                if (formula.length === 0) {
                    if (this.component.validate.required && errorRef) {
                        errorRef.innerHTML = `${AriFormUtils.getLangText(this.component.label || "")} ${AriFormUtils.getLangText('is required')}`;
                        errorRef.classList.remove(`${sdk_1.AriForm.tailwindPrefix}hidden`);
                    }
                    else if (errorRef) {
                        errorRef.classList.add(`${sdk_1.AriForm.tailwindPrefix}hidden`);
                    }
                    this.setValue('');
                }
                else if (!validateCodes) {
                    errorRef.innerHTML = `${AriFormUtils.getLangText("Only characters corresponding to the defined Scoring Criteria codes are allowed")}`;
                    errorRef.classList.remove(`${sdk_1.AriForm.tailwindPrefix}hidden`);
                    this.setValue('');
                }
                else if (!validateSyntax) {
                    errorRef.innerHTML = `${AriFormUtils.getLangText('Invalid formula')}`;
                    errorRef.classList.remove(`${sdk_1.AriForm.tailwindPrefix}hidden`);
                    this.setValue('');
                }
                else {
                    // ✅ Hợp lệ
                    errorRef.classList.add(`${sdk_1.AriForm.tailwindPrefix}hidden`);
                    this.validMathExpression = true;
                    this.setValue({ dataFormulaText: formula });
                }
                // Luôn đóng dropdown và remove event
                (_b = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.classList) === null || _b === void 0 ? void 0 : _b.add(`${sdk_1.AriForm.tailwindPrefix}hidden`);
                document.removeEventListener('click', closeWhenClickOut);
                (_c = this.refs[`${this.component.key}-salary-advance-formula-input`]) === null || _c === void 0 ? void 0 : _c.removeEventListener('input', handleInput);
            }
        };
        const openDropdownOnFocus = () => {
            var _a, _b, _c;
            if (this.component.disabled)
                return;
            (_b = (_a = this.refs[`${this.component.key}-salary-advance-container-dropdown-select`]) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(`${sdk_1.AriForm.tailwindPrefix}hidden`);
            (_c = this.refs[`${this.component.key}-salary-advance-formula-input`]) === null || _c === void 0 ? void 0 : _c.addEventListener('input', handleInput);
            // Tránh trigger đóng ngay sau mở
            setTimeout(() => {
                document.addEventListener('click', closeWhenClickOut);
            }, 0);
        };
        // ✅ Bắt khi người dùng bắt đầu bôi đen
        (_a = this.refs[`${this.component.key}-salary-advance-formula-input`]) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', () => {
            isDragging = true;
        });
        // ✅ Reset trạng thái bôi đen sau khi nhả chuột
        document.addEventListener('mouseup', () => {
            setTimeout(() => {
                isDragging = false;
            }, 50);
        });
        // ✅ Dùng focus để mở dropdown
        (_b = this.refs[`${this.component.key}-salary-advance-formula-input`]) === null || _b === void 0 ? void 0 : _b.addEventListener('focus', openDropdownOnFocus);
        // Load dữ liệu ban đầu
        const args = this.evalContext();
        args.form = this.root;
        this.emit('requestAri', {
            com: this.component,
            url: this.interpolate(this.component.ariaction),
            aribody: {},
            resultType: null,
            script: (result) => {
                if (result.length > 0) {
                    this.salaryCriteriaList = result;
                    this.refs[`${this.component.key}-salary-advance-formula-content`].innerHTML = this.renderSalaryCriteriaList();
                    this.getAllItems();
                }
            },
            args: args
        });
        // Tab switch
        (_c = this.refs[`${this.component.key}-salary-advance-formula-attributes`]) === null || _c === void 0 ? void 0 : _c.addEventListener('click', () => {
            var _a, _b, _c;
            (_a = this.refs[`${this.component.key}-salary-advance-formula-attributes`]) === null || _a === void 0 ? void 0 : _a.classList.add(`${sdk_1.AriForm.tailwindPrefix}bg-[#BFD9FF]`);
            (_b = this.refs[`${this.component.key}-salary-advance-formula-operation`]) === null || _b === void 0 ? void 0 : _b.classList.remove(`${sdk_1.AriForm.tailwindPrefix}bg-[#BFD9FF]`);
            (_c = this.refs[`${this.component.key}-salary-advance-formula-operation`]) === null || _c === void 0 ? void 0 : _c.classList.add(`${sdk_1.AriForm.tailwindPrefix}bg-[#F4F4F4]`);
            this.refs[`${this.component.key}-salary-advance-formula-content`].innerHTML = this.renderSalaryCriteriaList();
            this.tabChoose = 'attributes';
            this.getAllItems();
        });
        (_d = this.refs[`${this.component.key}-salary-advance-formula-operation`]) === null || _d === void 0 ? void 0 : _d.addEventListener('click', () => {
            var _a, _b, _c;
            (_a = this.refs[`${this.component.key}-salary-advance-formula-operation`]) === null || _a === void 0 ? void 0 : _a.classList.add(`${sdk_1.AriForm.tailwindPrefix}bg-[#BFD9FF]`);
            (_b = this.refs[`${this.component.key}-salary-advance-formula-attributes`]) === null || _b === void 0 ? void 0 : _b.classList.remove(`${sdk_1.AriForm.tailwindPrefix}bg-[#BFD9FF]`);
            (_c = this.refs[`${this.component.key}-salary-advance-formula-attributes`]) === null || _c === void 0 ? void 0 : _c.classList.add(`${sdk_1.AriForm.tailwindPrefix}bg-[#F4F4F4]`);
            this.refs[`${this.component.key}-salary-advance-formula-content`].innerHTML = this.renderOperations();
            this.tabChoose = 'operation';
            this.getAllItems();
        });
        return super.attach(element);
    }
    updateValue(...args) {
        return this.updateComponentValue(...args);
    }
}
SalaryAdvanceFormulaComponent.editForm = salaryadvanceformula_form_1.default;
SalaryAdvanceFormulaComponent.builderInfo = {
    title: 'Salary Advance Formula',
    group: 'advanced',
    icon: 'wrench',
    weight: 70,
    documentation: 'http://help.ari.form/userguide/',
    schema: SalaryAdvanceFormulaComponent.schema()
};
exports.default = SalaryAdvanceFormulaComponent;
